import { ChipProps } from '@material-ui/core/Chip';

type StatusKey =
  | 'leads'
  | 'onboarding'
  | 'development'
  | 'handover'
  | 'finalization'
  | 'finished';

const STATUS_CONFIG: Record<StatusKey, { label: string; color: ChipProps['color'] }> = {
  leads: { label: 'Leads', color: 'default' },
  onboarding: { label: 'Onboarding', color: 'secondary' },
  development: { label: 'Development', color: 'secondary' },
  handover: { label: 'Handover', color: 'secondary' },
  finalization: { label: 'Finalization', color: 'secondary' },
  finished: { label: 'Finished', color: 'primary' },
};

export const getSystemStatusChipColor = (status?: string): ChipProps['color'] => {
  if (!status) {
    return 'default';
  }

  const key = status.toLowerCase() as StatusKey;
  const config = STATUS_CONFIG[key];
  return config?.color ?? 'default';
};

export const formatSystemStatus = (status?: string): string | undefined => {
  if (!status) {
    return undefined;
  }

  const key = status.toLowerCase() as StatusKey;
  return STATUS_CONFIG[key]?.label;
};
